// src/services/alertService.js
import Swal from "sweetalert2";

// 🔹 Generic alert function
export const showAlert = (type, message, callback) => {
  let config = {
    icon: type,
    title: type === "success" ? "Success!" : type === "error" ? "Error" : "Notice",
    text: message,
  };

  // If it's a success and callback is passed → close modal after confirm
  if (type === "success" && callback) {
    Swal.fire(config).then(() => callback());
  } else {
    Swal.fire(config);
  }
};
